import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { withRouter } from 'react-router';
import classNames from 'classnames';
import styles from './KioskDoorLayout.styles';
import { KioskFooter, KioskHeader, KioskDoorMain, KioskIdelScreen } from '..';

export class KioskDoorLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };

  // handleClick = () => {
  //   this.props.history.push('/KioskFeedback');
  //   this.props.history.push('/KioskFeedback');
  // };

  // handleBack = () => {
  //   this.props.history.push('/KioskConfirmUser');
  //   this.props.history.push('/KioskConfirmUser');
  // };

  render() {
    const { classes } = this.props;
    var customFooterBottom;
    if (window.screen.width >= 1440) {
      customFooterBottom = '-28%';
    } else {
      customFooterBottom = '0%';
    }
    return (
      <div className={classNames(classes.container)}>
        <KioskHeader />
        <KioskDoorMain
        // handleClick={this.handleClick}
        // handleBack={this.handleBack}
        />
        <KioskFooter
          customFooterBottom={customFooterBottom}
          isLanguageBarAllowd={true}
        />
        <KioskIdelScreen />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(KioskDoorLayout);
